import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import useSEO from "../lib/useSEO";

export default function Blog() {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useSEO({
        title: "Blog | İstanbul Dövme Silme",
        description:
            "Dövme silme, Pico lazer, Fraksiyonel CO2 ve iz görünümü değerlendirmesi hakkında bilgilendirici yazılar.",
        canonical: "https://www.istanbuldovmesilme.com/blog",
    });

    useEffect(() => {
        api.get("/blog")
            .then((r) => setPosts(r.data))
            .finally(() => setLoading(false));
    }, []);

    return (
        <section className="py-20 md:py-28">
            <div className="max-w-[1200px] mx-auto px-6 md:px-12 lg:px-16">
                <p className="text-xs uppercase tracking-[0.3em] text-cyan-300/80 mb-3">
                    Blog
                </p>
                <h1 className="font-display text-4xl md:text-6xl text-white tracking-tight mb-12 text-balance">
                    Bilgi ve süreç paylaşımları
                </h1>

                {loading && <p className="text-zinc-500">Yükleniyor...</p>}

                {!loading && posts.length === 0 && (
                    <p className="text-zinc-500">Henüz yazı yok.</p>
                )}

                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {posts.map((p) => (
                        <Link
                            key={p.id}
                            to={`/blog/${p.slug}`}
                            className="group bg-[#0E0E0E] border border-white/5 rounded-2xl overflow-hidden hover:border-cyan-400/30 transition-all"
                            data-testid={`blog-card-${p.slug}`}
                        >
                            {p.cover_image && (
                                <div className="aspect-video overflow-hidden">
                                    <img
                                        src={p.cover_image}
                                        alt={p.title}
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                    />
                                </div>
                            )}
                            <div className="p-6">
                                <h3 className="font-display text-xl text-white mb-2 tracking-tight group-hover:text-cyan-300 transition-colors">
                                    {p.title}
                                </h3>
                                <p className="text-sm text-zinc-400 line-clamp-3 leading-relaxed">
                                    {p.excerpt}
                                </p>
                                <div className="mt-4 flex flex-wrap gap-2">
                                    {p.tags?.slice(0, 3).map((t) => (
                                        <span
                                            key={t}
                                            className="text-[10px] uppercase tracking-wider text-cyan-300/80 border border-cyan-400/20 rounded-full px-2 py-0.5"
                                        >
                                            {t}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}
